/**
 * A dotted document path (`exterior.walls`) set on a plain object, copying
 * along the way. Pure, and in a module of its own so that the pure patch
 * builders (`structurePatches.ts`) can use it without importing the
 * Firestore adapter — which initialises the SDK at load and throws
 * `auth/invalid-api-key` in a test with no environment.
 */
export function setPath(
  obj: Record<string, unknown>,
  path: string,
  value: unknown
): Record<string, unknown> {
  const [head, ...rest] = path.split('.');
  if (!rest.length) return { ...obj, [head]: value };
  const inner = (
    obj[head] && typeof obj[head] === 'object' ? obj[head] : {}
  ) as Record<string, unknown>;
  return { ...obj, [head]: setPath(inner, rest.join('.'), value) };
}
